import { Link } from '@material-ui/core';
import React from 'react';
import { useHistory } from 'react-router-dom';

const MuiRouterLink = (props) => {
  const {
    href,
    ...rest
  } = props;
  const history = useHistory();

  return (<Link {...rest} onClick={() => history.replace(props.href)}></Link>)
};

export default MuiRouterLink